import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISignin_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISignin_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetLanguage: string;
  GetLanguage_dummy: string;
  LoginKullaniciKontrol: any[];
  LoginKullaniciKontrol_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  Signin: any;
  Signin_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  goToNextScreenAfterLogin: any;
  goToNextScreenAfterLogin_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  LoginPlasiyerKontrol: any[];
  LoginPlasiyerKontrol_dummy: any[];
}

export class Signin_ScreenBase extends React.PureComponent<
  ISignin_ScreenProps,
  any
> {
  ml = [
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 381410,
          PropertyName: "value",
          Value: "B2B Sistemi",
          TagName: "lblTitle_value",
        },
        {
          Id: 709760,
          PropertyName: "tab",
          Value: "Bayi Girişi",
          TagName: "TabItem1_0_tab",
        },
        {
          Id: 673155,
          PropertyName: "tab",
          Value: "Plasiyer Girişi",
          TagName: "TabItem1_1_tab",
        },
        {
          Id: 378667,
          PropertyName: "value",
          Value:
            "Kuika Platformu İle Sisya Teknoloji Tarafından Geliştirilmiştir",
          TagName: "lblQ_value",
        },
        {
          Id: 172872,
          PropertyName: "placeholder",
          Value: "Müşteri Kodu",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 5436,
          PropertyName: "placeholder",
          Value: "Kullanıcı Kodu",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 452791,
          PropertyName: "placeholder",
          Value: "Şifre",
          TagName: "txtPassword_placeholder",
        },
        {
          Id: 641651,
          PropertyName: "label",
          Value: "Giriş Yap",
          TagName: "btnSignIn_label",
        },
        {
          Id: 833147,
          PropertyName: "placeholder",
          Value: "Kullanıcı Kodu",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 121494,
          PropertyName: "placeholder",
          Value: "Şifre",
          TagName: "Password1_placeholder",
        },
        {
          Id: 814771,
          PropertyName: "label",
          Value: "Giriş Yap",
          TagName: "Button1_label",
        },
      ],
    },
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 381410,
          PropertyName: "value",
          Value: "B2B DEALER SYSTEM",
          TagName: "lblTitle_value",
        },
        {
          Id: 709760,
          PropertyName: "tab",
          Value: "DEALER ENTRANCE",
          TagName: "TabItem1_0_tab",
        },
        {
          Id: 673155,
          PropertyName: "tab",
          Value: "CUSTOMER REPRE.. LOG IN",
          TagName: "TabItem1_1_tab",
        },
        {
          Id: 378667,
          PropertyName: "value",
          Value: "DEVELOPED BY SISYA TECHNOLOGY WITH KUIKA PLATFORM",
          TagName: "lblQ_value",
        },
        {
          Id: 172872,
          PropertyName: "placeholder",
          Value: "CUSTOMER CODE",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 5436,
          PropertyName: "placeholder",
          Value: "USER CODE",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 452791,
          PropertyName: "placeholder",
          Value: "PASSWORD",
          TagName: "txtPassword_placeholder",
        },
        {
          Id: 641651,
          PropertyName: "label",
          Value: "LOG IN",
          TagName: "btnSignIn_label",
        },
        {
          Id: 177874,
          PropertyName: "value",
          Value: "FORGET PASSWORD",
          TagName: "Label3_value",
        },
        {
          Id: 833147,
          PropertyName: "placeholder",
          Value: "USER CODE",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 121494,
          PropertyName: "placeholder",
          Value: "PASSWORD",
          TagName: "Password1_placeholder",
        },
        {
          Id: 814771,
          PropertyName: "label",
          Value: "LOG IN",
          TagName: "Button1_label",
        },
        {
          Id: 53398,
          PropertyName: "value",
          Value: "FORGET PASSWORD",
          TagName: "Label4_value",
        },
        {
          Id: 30264338,
          PropertyName: "8c28b1ac-99b3-b862-51f6-94ce7a289490_notify",
          Value: "USER NOT FOUND. PLEASE CHECK YOUR LOGIN INFORMATION",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 12021284,
          PropertyName: "a8cc0112-2c71-7fdf-886f-2c1b2cebbf49_notify",
          Value: "USER NOT FOUND. PLEASE CHECK YOUR LOGIN INFORMATION",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 381410,
          PropertyName: "value",
          Value: "Système B2B pour distributeurs",
          TagName: "lblTitle_value",
        },
        {
          Id: 709760,
          PropertyName: "tab",
          Value: "Connexion distributeur",
          TagName: "TabItem1_0_tab",
        },
        {
          Id: 673155,
          PropertyName: "tab",
          Value: "Connexion commercial",
          TagName: "TabItem1_1_tab",
        },
        {
          Id: 378667,
          PropertyName: "value",
          Value: "Développé par Sisya Technologie via la plateforme Kuika",
          TagName: "lblQ_value",
        },
        {
          Id: 172872,
          PropertyName: "placeholder",
          Value: "Code client",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 5436,
          PropertyName: "placeholder",
          Value: "Code utilisateur",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 452791,
          PropertyName: "placeholder",
          Value: "Mot de passe",
          TagName: "txtPassword_placeholder",
        },
        {
          Id: 641651,
          PropertyName: "label",
          Value: "Se connecter",
          TagName: "btnSignIn_label",
        },
        {
          Id: 177874,
          PropertyName: "value",
          Value: "Mot de passe oublié?",
          TagName: "Label3_value",
        },
        {
          Id: 833147,
          PropertyName: "placeholder",
          Value: "Code utilisateur",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 121494,
          PropertyName: "placeholder",
          Value: "Mot de passe",
          TagName: "Password1_placeholder",
        },
        {
          Id: 814771,
          PropertyName: "label",
          Value: "Se connecter",
          TagName: "Button1_label",
        },
        {
          Id: 53398,
          PropertyName: "value",
          Value: "Mot de passe oublié?",
          TagName: "Label4_value",
        },
        {
          Id: 8462260,
          PropertyName: "8c28b1ac-99b3-b862-51f6-94ce7a289490_notify",
          Value: "Utilisateur introuvable. Veuillez vérifier vos informations.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 7622998,
          PropertyName: "a8cc0112-2c71-7fdf-886f-2c1b2cebbf49_notify",
          Value: "Utilisateur introuvable. Veuillez vérifier vos informations.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 381410,
          PropertyName: "value",
          Value: "Sistema de distribuidores B2B",
          TagName: "lblTitle_value",
        },
        {
          Id: 709760,
          PropertyName: "tab",
          Value: "Inicio de sesión para distribuidores",
          TagName: "TabItem1_0_tab",
        },
        {
          Id: 673155,
          PropertyName: "tab",
          Value: "Inicio de sesión para vendedores",
          TagName: "TabItem1_1_tab",
        },
        {
          Id: 378667,
          PropertyName: "value",
          Value: "Desarrollado por Sisya Technologia con la plataforma Kuika",
          TagName: "lblQ_value",
        },
        {
          Id: 172872,
          PropertyName: "placeholder",
          Value: "Codigo de Cliente",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 5436,
          PropertyName: "placeholder",
          Value: "Codigo de Usuario",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 452791,
          PropertyName: "placeholder",
          Value: "Contraseña",
          TagName: "txtPassword_placeholder",
        },
        {
          Id: 641651,
          PropertyName: "label",
          Value: "Iniciar sesión",
          TagName: "btnSignIn_label",
        },
        {
          Id: 177874,
          PropertyName: "value",
          Value: " ¿Olvidaste tu contraseña? ",
          TagName: "Label3_value",
        },
        {
          Id: 833147,
          PropertyName: "placeholder",
          Value: "Codigo de Usuario",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 121494,
          PropertyName: "placeholder",
          Value: "Contraseña",
          TagName: "Password1_placeholder",
        },
        {
          Id: 814771,
          PropertyName: "label",
          Value: "Iniciar sesión",
          TagName: "Button1_label",
        },
        {
          Id: 53398,
          PropertyName: "value",
          Value: " ¿Olvidaste tu contraseña? ",
          TagName: "Label4_value",
        },
        {
          Id: 92537218,
          PropertyName: "8c28b1ac-99b3-b862-51f6-94ce7a289490_notify",
          Value:
            "No se encontró ningún usuario. Por favor, comprueba los datos.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 90111279,
          PropertyName: "a8cc0112-2c71-7fdf-886f-2c1b2cebbf49_notify",
          Value:
            "No se encontró ningún usuario. Por favor, comprueba los datos.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "71a53a90-df53-4114-8b26-326821b9be65",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 381410, PropertyName: "value", Value: "B2B Bayi Sistemi" },
        { Id: 709760, PropertyName: "tab", Value: "Bayi Girişi" },
        { Id: 172872, PropertyName: "placeholder", Value: "Müşteri Kodu" },
        { Id: 5436, PropertyName: "placeholder", Value: "Kullanıcı Kodu" },
        { Id: 452791, PropertyName: "placeholder", Value: "Şifre" },
        { Id: 641651, PropertyName: "label", Value: "Giriş Yap" },
        { Id: 177874, PropertyName: "value", Value: "Şifremi Unuttum ?" },
        { Id: 673155, PropertyName: "tab", Value: "Plasiyer Girişi" },
        { Id: 833147, PropertyName: "placeholder", Value: "Kullanıcı Kodu" },
        { Id: 121494, PropertyName: "placeholder", Value: "Şifre" },
        { Id: 814771, PropertyName: "label", Value: "Giriş Yap" },
        { Id: 53398, PropertyName: "value", Value: "Şifremi Unuttum ?" },
        {
          Id: 378667,
          PropertyName: "value",
          Value:
            "Kuika Platformu İle Sisya Teknoloji Tarafından Geliştirilmiştir",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.signin_172872_value_kuikaTextInputRef = React.createRef();
    this.signin_5436_value_kuikaTextInputRef = React.createRef();
    this.signin_833147_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetLanguage: "",
      LoginKullaniciKontrol: [],
      IfThenElse: false,
      goToNextScreenAfterLogin: "",
      NAVIGATE: "",
      LoginPlasiyerKontrol: [],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("signin", "");
      return;
    }

    this.fillFormInitValues();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight("signin", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("signin", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  SigninComponent_641651_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GetLanguage = await ReactSystemFunctions.getLanguage(
      this.ml,
      this.defaultML
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SigninComponent_641651_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SigninComponent_641651_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      musteriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "signin_172872_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      KullaniciKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "signin_5436_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Signin/SigninComponent_641651_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.LoginKullaniciKontrol = result?.data.loginKullaniciKontrol;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SigninComponent_641651_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SigninComponent_641651_onClick_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "8c28b1ac_99b3_b862_51f6_94ce7a289490_notify",
        this.defaultML,
        "Kullanıcı Bulunamadı. Lütfen Bilgilerinizi Kontrol Edin."
      ),
      ReactSystemFunctions.convertToTypeByName("danger", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SigninComponent_641651_onClick_else2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "signin_452791_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "signin_452791_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Signin = (
      (await ReactSystemFunctions.signin(
        this,
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "signin_5436_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "signin_452791_value",
            "value",
            "",
            "",
            ""
          )
        )
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SigninComponent_641651_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        stateVars.LoginKullaniciKontrol !== undefined
          ? stateVars.LoginKullaniciKontrol?.length > 0
            ? stateVars.LoginKullaniciKontrol[0].id
            : null
          : this.state.LoginKullaniciKontrol?.length > 0
          ? this.state.LoginKullaniciKontrol[0].id
          : null,
        null
      )
    ) {
      isErrorOccurred = await this.SigninComponent_641651_onClick_if2();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.SigninComponent_641651_onClick_else2();
      if (isErrorOccurred) return true;
    }

    stateVars.tmpBoolResult =
      await ReactSystemFunctions.goToNextScreenAfterLogin(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SigninComponent_177874_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Signin",
      "ForgotPassword",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SigninComponent_814771_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GetLanguage = await ReactSystemFunctions.getLanguage(
      this.ml,
      this.defaultML
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SigninComponent_814771_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SigninComponent_814771_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KullaniciKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "signin_833147_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Signin/SigninComponent_814771_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.LoginPlasiyerKontrol = result?.data.loginPlasiyerKontrol;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SigninComponent_814771_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SigninComponent_814771_onClick_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "a8cc0112_2c71_7fdf_886f_2c1b2cebbf49_notify",
        this.defaultML,
        "Kullanıcı Bulunamadı. Lütfen Bilgilerinizi Kontrol Edin."
      ),
      ReactSystemFunctions.convertToTypeByName("danger", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SigninComponent_814771_onClick_else2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "signin_121494_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "signin_121494_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Signin = (
      (await ReactSystemFunctions.signin(
        this,
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "signin_833147_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "signin_121494_value",
            "value",
            "",
            "",
            ""
          )
        )
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  SigninComponent_814771_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        stateVars.LoginPlasiyerKontrol !== undefined
          ? stateVars.LoginPlasiyerKontrol?.length > 0
            ? stateVars.LoginPlasiyerKontrol[0].id
            : null
          : this.state.LoginPlasiyerKontrol?.length > 0
          ? this.state.LoginPlasiyerKontrol[0].id
          : null,
        null
      )
    ) {
      isErrorOccurred = await this.SigninComponent_814771_onClick_if2();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.SigninComponent_814771_onClick_else2();
      if (isErrorOccurred) return true;
    }

    stateVars.tmpBoolResult =
      await ReactSystemFunctions.goToNextScreenAfterLogin(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SigninComponent_53398_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Signin",
      "ForgotPassword",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
